import api from "../../api/user.js"
import * as mutations from "../mutations.js"
import router from "../../router/index.js"
import * as actions from "../actions.js"
import * as NAMESPACES from "../namespaceStore.js"

export default {
    namespaced: true,
    state: {
        user: null,
        token: null,
        isLoggedIn: false,
        actionLoading: false,
    },
    getters: {
        isLoggedIn: state => state.isLoggedIn,
        user: state => state.user,
        token: state => state.token,
        actionLoading: state => state.actionLoading,
    },
    mutations: {
        [mutations.SET_USER](state, user) {
            state.user = user;
            if (user) {
                state.isLoggedIn = true;
            } else {
                state.isLoggedIn = false;
            }
        },
        [mutations.SET_ACTION_LOADING](state, actionLoading) {
            state.actionLoading = actionLoading;
        }
    },
    actions: {
        // Vérifier l'état d'authentification au démarrage
        checkAuth({ commit, dispatch }) {
            return new Promise((resolve, reject) => {
                api.checkAuth().then(response => {
                    if (response.data.isAuthenticated) {
                        commit(mutations.SET_USER, response.data.user);
                        let promiseList = [];
                        // Récupérer les ressources
                        promiseList.push(dispatch(NAMESPACES.THEME + '/' + actions.GET_RESSOURCES, null, { root: true }).then(() => {
                            let promiseList = [];
                            promiseList.push(dispatch(NAMESPACES.THEME + '/' + actions.SET_FONT_FAMILY, null, { root: true }));
                            promiseList.push(dispatch(NAMESPACES.THEME + '/' + actions.GET_COMPOSITIONS, null, { root: true }));
                            promiseList.push(dispatch(NAMESPACES.THEME + '/' + actions.GET_THEMES, null, { root: true }));
                            Promise.all(promiseList).then(() => {
                                resolve(response.data);
                            }).catch(error => {
                                commit(mutations.SET_USER, null);
                                reject(error);
                            });
                        }));
                    } else {
                        commit(mutations.SET_USER, null);
                        resolve(response.data);
                    }
                }).catch(error => {
                    commit(mutations.SET_USER, null);
                    reject(error);
                });
            });
        },
        login(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit(mutations.SET_ACTION_LOADING, true);
                api.login(payload).then(response => {
                    context.commit(mutations.SET_USER, response.data.user);
                    let promiseList = [];
                    // Récupérer les ressources
                    promiseList.push(context.dispatch(NAMESPACES.THEME + '/' + actions.GET_RESSOURCES, null, { root: true }).then(() => {
                        let promiseList = [];
                        promiseList.push(context.dispatch(NAMESPACES.THEME + '/' + actions.SET_FONT_FAMILY, null, { root: true }));
                        promiseList.push(context.dispatch(NAMESPACES.THEME + '/' + actions.GET_COMPOSITIONS, null, { root: true }));
                        promiseList.push(context.dispatch(NAMESPACES.THEME + '/' + actions.GET_THEMES, null, { root: true }));
                        Promise.all(promiseList).then(() => {
                            resolve(response.data);
                        }).catch(error => {
                            context.commit(mutations.SET_USER, null);
                            reject(error);
                        });
                    }));
                }).catch(error => {
                    reject(error);
                }).finally(() => {
                    context.commit(mutations.SET_ACTION_LOADING, false);
                });
            });
        },
        register(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit(mutations.SET_ACTION_LOADING, true);
                api.register(payload).then(response => {
                    context.commit(mutations.SET_USER, response.data.user);
                    resolve(response.data);
                }).catch(error => {
                    reject(error);
                }).finally(() => {
                    context.commit(mutations.SET_ACTION_LOADING, false);
                });
            });
        },
        logout(context) {
            api.logout().then(response => {
                context.commit(mutations.SET_USER, null);
                context.commit(NAMESPACES.THEME + '/' + mutations.DEFAULT, null, { root: true });
                router.push('/login');
            }).catch(error => {
                reject(error);
            });
        }
    }
}